<main [@fadeInOut] id="main-heading" role="main" tabindex="0" [@fadeInOut]>
  <div class="container-fluid">
    <div class="d-flex flex-column main-heading-div">
      <div class="mx-5 ps-4 py-3 text-decoration-none">
        <a class="pointer text-decoration-none" href="javascript:void(0);" (click)="returnToInventory()" tabindex="0">
          <i class="fal fa-caret-left"></i>Return to Manage DI
        </a>
      </div>

      <div class="ms-5 pe-5 ps-4">
        <div class="col-sm-3 ps-1 me-3 align-self-end">
          <h1>{{headerVar}} Details</h1>
        </div>
        <div class="flex-grow-1 text-end accordion-links align-self-end">
          <a href='javascript:void(0)' (click)="collapseAll()">Collapse All </a> |
          <a href='javascript:void(0)' (click)="expandAll()">Expand All </a>
        </div>
      </div>

      <div class="ms-5 ps-4 me-5">
        <div class="flex-row">

          <div class="d-flex" *ngIf="itemType === 'model'">

            <div class="col-sm-2 top-space panel-sticky">
              <div class="card card-primary form-panel me-2 fixed">
                <div class="card-header bg-primary text-white">Identification</div>
                <div class="card-body">
                  <table class="table table-condensed">
                    <ng-container
                      *ngIf="showLegacy; then legacyModelTemplate else regulationModelTemplate">
                    </ng-container>
                      <ng-template #legacyModelTemplate>
                        <tbody>
                          <tr>
                            <th>EUDAMED DI</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Eudamed DI')"> <span class="breakAll">{{eudamedDi}}</span></td>
                          </tr>
                          <tr>
                            <th>EUDAMED DI Issuing Agency</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Eudamed DI')"> <span>{{eudamedDiIssuingAgency}}</span></td>
                          </tr>
                          <tr>
                            <th>{{headerVar}} Revision Number</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Revision Number')">
                              <span>{{revisionNumber}}</span>
                              <small>
                                (<a href="javascript:void(0);" (click)="displayRevisionHistory($event)">
                                  Revision History
                                </a>)
                              </small>
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                      <ng-template #regulationModelTemplate>
                        <tbody>
                          <tr>
                            <th>Basic UDI-DI Number (BUDI-DI)</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Basic UDI-DI')"> <span class="breakAll">{{modelBUDI}}</span></td>
                          </tr>
                          <tr>
                            <th>Issuing Agency</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Basic UDI-DI')"> <span>{{modelAgency}}</span></td>
                          </tr>
                          <tr>
                            <th>{{headerVar}} Revision Number</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Revision Number')">
                              <span>{{revisionNumber}}</span>
                              <small>
                                (<a href="javascript:void(0);" (click)="displayRevisionHistory($event)">
                                  Revision History
                                </a>)
                              </small>
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                    <tbody *ngIf="hasHaStateHistory()">
                      <tr>
                        <th>Health Authority State History</th>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0);" class="ha-history-link" (click)="openHaStateHistory($event)">
                            View Health Authority State History
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="status mt-2">
                <div class="status-block highlight-fill bordered">
                </div>
                <span>Default - value shared across Health Authorities</span>
              </div>
            </div>

            <div class="col-sm-10 top-space">
              <ejs-accordion #properties expandMode='Mulitple' (created)='accordionCreated($event)' id="modelAccordion">

                <e-accordionitems>
                  <e-accordionitem header=' Identification and Classification '
                                   [content]='modelidentificationclassification'>
                  </e-accordionitem>
                  <e-accordionitem header=' Model or Device Group Characteristics  ' [content]='groupcharacteristics'>
                  </e-accordionitem>
                  <e-accordionitem header=' Clinical Investigation and Certificate Links '
                                   [content]='clinicalinvestigation'>
                  </e-accordionitem>
                  <e-accordionitem header=' Non-Health Authority' [content]='modelnonhealth'>
                  </e-accordionitem>
                </e-accordionitems>
              </ejs-accordion>
              <!--</div>-->
            </div>

          </div>
          <div class="d-flex" *ngIf="itemType === 'device'">
            <div class="col-sm-2 top-space panel-sticky">
              <div class="card card-primary form-panel me-2">
                <div class="card-header bg-primary text-white">Identification</div>

                <div class="card-body">
                  <table class="table table-condensed">
                    <ng-container
                      *ngIf="showLegacy; then legacyDeviceTemplate else regulationDeviceTemplate">
                    </ng-container>
                      <ng-template #legacyDeviceTemplate>
                        <tbody>
                          <tr>
                            <th>EUDAMED ID</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Eudamed ID')">
                              <span class="breakAll">{{eudamedId}}</span>
                            </td>
                          </tr>
                          <tr>
                            <th>{{headerVar}} Revision Number</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Revision Number')">
                              <span>{{revisionNumber}}</span>
                              <small>
                                (<a href="javascript:void(0);" (click)="displayRevisionHistory($event)">
                                  Revision History
                                </a>)
                              </small>
                            </td>
                          </tr>
                          <tr>
                            <th>EUDAMED DI</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Eudamed DI')"> <span class="breakAll">{{budi}}</span></td>
                          </tr>
                          <tr>
                            <th>EUDAMED ID Issuing Agency</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Eudamed ID Issuing Agency')"> <span>{{eudamedIdIssuingAgency}}</span></td>
                          </tr>
                          <tr>
                            <th>Product SKU</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Product SKU')">
                              <span class="breakAll">{{productSKU}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                      <ng-template #regulationDeviceTemplate>
                        <tbody>
                          <tr>
                            <th>Primary Device Identifier (DI)</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Primary DI')">
                              <span class="breakAll">{{udiDI}}</span>
                            </td>
                          </tr>
                          <tr>
                            <th>{{headerVar}} Revision Number</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Revision Number')">
                              <span>{{revisionNumber}}</span>
                              <small>
                                (<a href="javascript:void(0);" (click)="displayRevisionHistory($event)">
                                  Revision History
                                </a>)
                              </small>
                            </td>
                          </tr>
                          <tr>
                            <th>Basic UDI-DI Number (BUDI-DI)</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Basic UDI-DI')"> <span class="breakAll">{{budi}}</span></td>
                          </tr>
                          <tr>
                            <th>Primary Issuing Agency</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Primary DI Issuing Agency')"> <span>{{agency}}</span></td>
                          </tr>
                          <tr>
                            <th>Product SKU</th>
                          </tr>
                          <tr>
                            <td [ngClass]="isDefault('Product SKU')">
                              <span class="breakAll">{{productSKU}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                    <tbody *ngIf="hasHaStateHistory()">
                      <tr>
                        <th>Health Authority State History</th>
                      </tr>
                      <tr>
                        <td>
                          <a href="javascript:void(0);" class="ha-history-link" (click)="openHaStateHistory($event)">
                            View Health Authority State History
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="status mt-2">
                <div class="status-block highlight-fill bordered">
                </div>
                <span>Default - value shared across Health Authorities</span>
              </div>
            </div>

            <div class="flex-grow-1 top-space">

              <ejs-accordion #properties expandMode='Mulitple' (created)='accordionCreated($event)'
                             id="deviceAccordion">

                <e-accordionitems>
                  <e-accordionitem header='Identification and Classification' [content]='identificationclassification'>
                  </e-accordionitem>
                  <e-accordionitem header='Device Characteristics' [content]='devicecharacteristics'>
                  </e-accordionitem>
                  <e-accordionitem header='Packaging' [content]='packaging'>
                  </e-accordionitem>
                  <e-accordionitem header='Device Status and Marketing Information' [content]='devicemarketing'>
                  </e-accordionitem>
                  <e-accordionitem header='Device Registration and UDI Database Publication Information'
                                   [content]='deviceregistration'>
                  </e-accordionitem>
                  <e-accordionitem header='Containing Substances and Critical Warnings or Contraindications'
                                   [content]='substanceswarnings'>
                  </e-accordionitem>
                  <e-accordionitem header='Product Designer' [content]='productdesigner'>
                  </e-accordionitem>
                  <e-accordionitem header='Non-Health Authority' [content]='nonhealth'>
                  </e-accordionitem>
                </e-accordionitems>
              </ejs-accordion>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</main>


<div class="bottom-padding"></div>

<ejs-dialog #dialog id="dialog" [isModal]='isModal' [animationSettings]='animationSettings' [closeOnEscape]='true'
            [showCloseIcon]='false' [width]='modalWidth' [position]='position' [visible]='visible' [height]='modalHeight'
            (overlayClick)="onOverlayClick()" [hidden]='!visible'>

  <div class="card">
    <div class="card-header bg-primary">
      <h4 class="card-title"> Total Number of Revisions: {{revisions?.length}}</h4>
    </div>
    <div class="card-body">
      <table class="table table-inner table-striped">
        <thead>
        <th>Revision Number</th>
        <th>Creation Date</th>
        <th>Revised By</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of revisions; let i = index;">

            <td>{{item.revision}}</td>
            <td>{{item.createdDateTimeUtc | date:'MM/dd/yyyy hh:mm a'}}</td>
            <td>{{item.createdBy}}</td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer">
      <button id="revHistClose" class="btn btn-primary dialogButton" (click)="revisionHistoryClose($event)"
        data-ripple="true">Close</button>

    </div>
  </div>
</ejs-dialog>

<ejs-dialog id="haStateHistoryDetailsDialog" [isModal]='true' [animationSettings]='animationSettings'
            [closeOnEscape]='true' [width]="'60%'" [position]='position' [visible]='haStateHistoryDialogVisible'
            [showCloseIcon]='false' [hidden]="!haStateHistoryDialogVisible" [height]="'auto'"
            (close)="closeHaStateHistoryDialog()">

  <div class="card ha-state-history-dialog">
    <div class="card-header bg-primary">
      <h4 class="card-title">Health Authority State History</h4>
    </div>
    <div class="card-body">
      <div *ngIf="haStateHistoryLoading">Loading Health Authority state history...</div>
      <div *ngIf="!haStateHistoryLoading && (!haStateHistoryItems || haStateHistoryItems.length === 0)">
        No Health Authority state changes have been recorded for this item.
      </div>
      <div *ngIf="!haStateHistoryLoading && haStateHistoryItems && haStateHistoryItems.length > 0">
        <table class="table table-inner table-striped">
          <thead>
            <tr>
              <th>Date</th>
              <th>Previous State</th>
              <th>New State</th>
              <th>Action Type</th>
              <th>Modified By</th>
              <th>Reason</th>
              <th>Requested By</th>
              <th>Service Ticket</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of haStateHistoryItems">
              <td>{{(item.createDate || item.CreateDate) | date:'MM/dd/yyyy hh:mm a'}}</td>
              <td>{{getHaStateHistoryState(item, 'PreviousHealthAuthorityState')}}</td>
              <td>{{getHaStateHistoryState(item, 'NewHealthAuthorityState')}}</td>
              <td>{{item.actionType || item.ActionType}}</td>
              <td>{{getHaStateHistoryModifiedBy(item)}}</td>
              <td>{{item.reason || item.Reason}}</td>
              <td>{{item.requestedBy || item.RequestedBy}}</td>
              <td>{{item.serviceTicket || item.ServiceTicket}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card-footer">
      <button id="haStateHistoryClose" class="btn btn-primary dialogButton" (click)="closeHaStateHistoryDialog()"
        data-ripple="true">Close</button>
    </div>
  </div>
</ejs-dialog>

<!--Model Accordion sections-->
<ng-template #modelidentificationclassification let-data>
  <app-model-identification-classification [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly' [showLegacy]='showLegacy'>
  </app-model-identification-classification>
</ng-template>

<ng-template #groupcharacteristics let-data>
  <app-model-group-characteristics [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly' [showLegacy]='showLegacy'>
  </app-model-group-characteristics>
</ng-template>

<ng-template #clinicalinvestigation let-data>
  <app-clinical-investigation [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-clinical-investigation>
</ng-template>

<ng-template #modelnonhealth let-data>
  <app-model-non-health-authority [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-model-non-health-authority>
</ng-template>

<!-- Device Accordion sections-->
<ng-template #identificationclassification let-data>
  <app-identification-classification [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly' [showLegacy]='showLegacy'>
  </app-identification-classification>
</ng-template>

<ng-template #devicecharacteristics let-data>
  <app-device-characteristics [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-device-characteristics>
</ng-template>

<ng-template #packaging let-data>
  <app-packaging [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-packaging>
</ng-template>

<ng-template #devicemarketing let-data>
  <app-device-marketing [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-device-marketing>
</ng-template>

<ng-template #deviceregistration let-data>
  <app-device-registration [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-device-registration>
</ng-template>

<ng-template #substanceswarnings let-data>
  <app-substances-warnings [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-substances-warnings>
</ng-template>

<ng-template #productdesigner let-data>
  <app-product-designer [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-product-designer>
</ng-template>

<ng-template #nonhealth let-data>
  <app-non-health-authority [itemData]='itemData' [mapArray]='mapArray' [readOnly]='readOnly'>
  </app-non-health-authority>
</ng-template>
